import React from 'react';
import styled from 'styled-components';
import { TypeListItem } from '@spotify-internal/encore-web';
import Type from 'components/Type';
import * as tokens from 'styles';
import { IconProps } from '@spotify-internal/encore-web/types/src/core/components/Icon';

const ListItem = styled(TypeListItem)`
  text-align: left;
  display: flex;
  & > svg {
    max-width: 30px;
    max-height: 26px;
    min-width: 30px;
    min-height: 26px;
  }
`;

const Text = styled(Type.span)`
  margin-left: ${tokens.spacer12};
`;

type BenefitProps = {
  IconComponent: (props: IconProps) => JSX.Element;
  text: string;
};

const Benefit = ({ IconComponent, text }: BenefitProps) => {
  return (
    <ListItem>
      <IconComponent iconSize={64} />
      <Text>{text}</Text>
    </ListItem>
  );
};

export default Benefit;
